<div class="listing-card" *ngFor="let product of products">
  <div class="imageVideo">
    <div class="image">
      <div class="video">
        <!--<video class="vdo" inViewport [inViewportOptions]="{ threshold: [0] }" playsinline
               (inViewportAction)="onVideoIntersection($event)" poster="{{product.details.preview_video_image}}"
               src="{{product.details.preview_video}}#t=0.1" loop="1" preload="none" muted=""
               (mouseover)="playVideo($event.target)" (mouseout)="pauseVideo($event.target)"></video> -->
        <a [routerLink]="['/' + product.details.city.toLowerCase().toString() + '/' + product.details.slug]">
          <img src="{{product.details.preview_video_image}}">
        </a>
      </div>
      <div class="voice">
        <img src="assets/images/icons/sound.png" alt="" class="volumecontrol hidelg hideMobile"
             (click)="videoVolumeControl($event.target)">
      </div>
    </div>
  </div>
  <div class="details">
    <span>{{product.details.category_name}} </span>
    <h4>
      <a [routerLink]="['/' + product.details.city.toLowerCase().toString() + '/' + product.details.slug]">
        {{product.details.title}}
      </a>
    </h4>
    <p>
      <a [routerLink]="['/' + product.details.city.toLowerCase().toString() + '/' + product.details.slug]">
        {{product.details.short_description}}
      </a>
    </p>
    <a class="btn-yellow btn-yellow-bold center-block"
       [routerLink]="['/' + product.details.city.toLowerCase().toString() + '/' + product.details.slug]">
      Book Now
    </a>
  </div>
</div>
